import { render } from "./event_master.vue?vue&type=template&id=3ca15f7a&scoped=true"
import script from "./event_master.vue?vue&type=script&lang=js"
export * from "./event_master.vue?vue&type=script&lang=js"

import "./event_master.vue?vue&type=style&index=0&id=3ca15f7a&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca15f7a"]])

export default __exports__